import { getMinutesRoundedTimestamp } from "../../../utils";

// Taken once per page load, not per render: the option images are managed by admins and rarely change,
// and a timestamp per minute made every select box download its images again each minute. A reload
// still shows a newly uploaded image.
const PAGE_LOAD_TIMESTAMP = getMinutesRoundedTimestamp();

export const getOptionImageSrc = (image: string): string =>
  `${import.meta.env.VITE_BUCKET_URL}${image}?${PAGE_LOAD_TIMESTAMP}`;
